export default "__VITE_ASSET__CejYEvsM__"